import React from "react";
import { ChevronDownIcon } from "@radix-ui/react-icons";
import { cn } from "@/lib/utils";
import ModalButton from "@/components/Search/components/SearchFilterModal";
import { useCurrentRefinements } from "react-instantsearch";
import { FilterVersion } from "@/components/Search/types";
import FiltersIcon from "@/components/icons/Filters";
import { useProductCreatedRange } from "../SearchContextProvider";
import useRefinementExcludedAttributes from "../../hooks/useRefinementExcludedAttributes";

function MobileShowAllFilters({
  filterVersion,
}: {
  filterVersion: FilterVersion;
}) {
  const excludedAttributes = useRefinementExcludedAttributes();
  const { items } = useCurrentRefinements({
    excludedAttributes: excludedAttributes,
  });
  const { productCreatedRange } = useProductCreatedRange();

  const filtersCount =
    items.reduce((total, item) => total + item.refinements.length, 0) +
    (productCreatedRange ? 1 : 0);

  const ButtonVerticalFilterV1 = () => {
    return (
      <div className="flex justify-between items-center m-0 h-10 w-full">
        <small className="m-0">
          All Filters {filtersCount > 0 && `(${filtersCount} selected)`}
        </small>
        <div>
          <ChevronDownIcon
            className={cn(
              "h-6 w-6 shrink-0 text-brand font-bold transition-transform duration-200 text-gray-700 color-gray-700",
            )}
          />
        </div>
      </div>
    );
  };

  const ButtonVerticalFilterV2 = () => {
    const buttonText = `All filters${filtersCount > 0 ? ` (${filtersCount})` : ""}`;

    return (
      <div className="whitespace-nowrap group hover:bg-primary hover:text-white flex flex-row items-center h-11 rounded-full border-2 border-primary-500 bg-putty-50 text-primary-500 font-bold text-md py-2.5 px-6 gap-2 focus:outline-none focus:ring-2 cursor-pointer min-w-fit">
        <span className="font-bold text-primary-500 group-hover:text-white flex-shrink-0">
          {buttonText}
        </span>
        <FiltersIcon
          svgProps={{ width: 24, height: 24, className: "flex-shrink-0" }}
        />
      </div>
    );
  };

  const ButtonHorizontalFilterV1 = () => {
    return (
      <div
        className={`whitespace-nowrap group hover:bg-primary hover:text-white flex flex-row items-center h-11 w-auto rounded-full border-2 border-primary-500 bg-putty-50 text-primary-500 font-light text-md py-2.5 px-6 gap-2 focus:outline-none focus:ring-2 cursor-pointer`}
      >
        <span
          className={`text-primary-500 group-hover:text-white ${filtersCount > 0 ? "font-semibold" : "font-normal"}`}
        >
          All filters{filtersCount > 0 ? ` (${filtersCount})` : ""}
        </span>
        <FiltersIcon svgProps={{ width: 24, height: 24 }} />
      </div>
    );
  };

  return (
    <div className={`flex p-1 -mt-1`}>
      {filterVersion === FilterVersion.VerticalFilterV1 ? (
        <ModalButton triggerClassName="w-full">
          <ButtonVerticalFilterV1 />
        </ModalButton>
      ) : filterVersion === FilterVersion.VerticalFilterV2 ? (
        <ModalButton>
          <ButtonVerticalFilterV2 />
        </ModalButton>
      ) : filterVersion === FilterVersion.HorizontalFilter ? (
        <ModalButton triggerClassName="w-full">
          <ButtonHorizontalFilterV1 />
        </ModalButton>
      ) : null}
    </div>
  );
}

export default MobileShowAllFilters;
